export default __webpack_public_path__ + "static/media/secondCard.484d9273.png";